

























import { Vue, Component, Prop } from 'vue-property-decorator'
import { Nullable } from '@/types/general'

@Component({ name: 'v-long-press-button' })
export default class VLongPressButton extends Vue {
    /**
     * Button style type
     */
    @Prop({ type: String, default: 'primary' })
    type!: string

    /**
     * Button size
     *
     * @var {String}
     */
    @Prop({ type: String, default: 'md' })
    size!: 'xs' | 'sm' | 'md' | 'lg' | 'xl'

    /**
     * Icon name
     *
     * Reference: https://fontawesome.com/icons
     */
    @Prop({ type: String, required: true })
    icon!: string

    /**
     * Duration (seconds) to hold before emitting event
     */
    @Prop({ type: Number, default: 1 })
    duration!: number

    /**
     * Timer progress
     */
    counter: number = 0

    /**
     * Interval
     */
    timer: Nullable<NodeJS.Timer> = null

    /**
     * Start the timer
     *
     * Only activates on mouse click or space press.
     */
    begin(event: KeyboardEvent): void {
        if (!event.key || event.key === 'Space' || event.key === ' ') {
            if (this.timer === null) {
                this.timer = setInterval(() => {
                    this.counter += 1
                    if (this.counter >= this.duration) {
                        this.end()
                        this.$emit('click')
                    }
                }, 1000)
            }
        }
    }

    /**
     * End the timer (without emitting an event)
     */
    end(): void {
        if (this.timer !== null) {
            clearInterval(this.timer)
            this.counter = 0
            this.timer = null
        }
    }
}
